// extracted by mini-css-extract-plugin
export default {"banner":"NoteExpertInsidePageBanner_banner__-+uHJ"};